<ng-container *transloco="let t">
  <div class="flex w-[60rem] flex-col gap-4">
    <div class="form-group row items-center">
      <span class="prepend col-4">{{ t("update-custom-campaign-name.custom_campaign_naming") }}</span>
      <div class="col-8">
        <mat-slide-toggle color="primary" [checked]="canEdit" (change)="canEdit = $event.checked"></mat-slide-toggle>
      </div>
    </div>
    @if (canEdit) {
      @if (edit) {
        <IInput
          [label]="t('update-custom-campaign-name.campaign_name_pattern')"
          class="w-full"
          [placeholder]="t('update-custom-campaign-name.campaign_name_pattern')"
          [value]="customCampaignName ?? ''"
          (valueChange)="customCampaignName = $event"
          [maxLength]="256"
          (keydown.enter)="validPattern() && update()"
        />
      }
      @if (!edit) {
        <div class="flex items-center gap-2">
          <div
            [innerHTML]="
              (customCampaignNameHighlighted !== null ? customCampaignNameHighlighted : '')
                | customCampaignNameHighlightPipe
            "
          ></div>

          <IButton
            color="gray"
            size="sm"
            variant="ghost"
            [label]="t('common.edit')"
            (onClick)="setEditCustomCampaignName()"
          />
        </div>
      }
    }
    @if (canEdit) {
      <div class="mt-4">
        <span> {{ t("update-custom-campaign-name.customize_tokens") }} </span>
        <ul class="p-4">
          @for (token of CustomCampaignNameTokens; track token) {
            <li class="pointer my-1">
              <a (click)="addTokenToInput(token)" class="hover:underline">
                <code>{{ token }}</code>
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </div>
  <div class="flex justify-end gap-2">
    <IButton color="white" [label]="t('common.cancel')" (onClick)="modalRef.close()" />

    <IButton type="submit" [label]="t('common.update')" (onClick)="update()" [disabled]="!validPattern()" />
  </div>
</ng-container>
